import { getLocalStorage, getApiPrefixURL } from '../utils/util';
import { API_STATUS_INFO, MIGRATION_STATUS } from '../utils/appConstants';
import { httpPost, httpGetMigrateStatus } from '../services/service';
const {
  UNAUTHORIZED
} = API_STATUS_INFO;
const {
  INPROGRESS,
  VALIDATING
} = MIGRATION_STATUS;
let statusTimer;
export function validateAndDeploy(config) {
  const {
    isValidate,
    isOverwrite,
    queuedDataList,
    isImportFileEnabled,
    importFileUniqueID
  } = config;
  const migrationOption = {
    validate: isValidate,
    deploy: !isValidate,
    overwrite: isOverwrite
  };
  const migrationDataList = JSON.parse(JSON.stringify(queuedDataList));
  const request = JSON.stringify({
    migrationOption: migrationOption,
    migrationDataList: [...migrationDataList]
  });
  const sourceSessionInfo = JSON.parse(getLocalStorage('sourceSessionInfo'));
  const targetSessionInfo = JSON.parse(getLocalStorage('targetSessionInfo'));
  const sforceSessionInfo = isImportFileEnabled ? importFileUniqueID : `{"acessToken":"${sourceSessionInfo.access_token}","serviceEndpoint":"${sourceSessionInfo.instance_url}"}`;
  const tforceSessionInfo = `{"acessToken":"${targetSessionInfo.access_token}","serviceEndpoint":"${targetSessionInfo.instance_url}" }`;
  const deployEndPoint = isImportFileEnabled ? 'import' : 'migrate';
  httpPost(`${getApiPrefixURL()}/svmx/a360/migration/${deployEndPoint}`, sforceSessionInfo, tforceSessionInfo, request).then(response => {
    console.log('response', response);
    const {
      status,
      statusInfo
    } = response;
    if (status === 401 && statusInfo === UNAUTHORIZED) {
      // show error and stop progress bar.
      clearInterval(statusTimer);
      const validateDeploySessionExpEvent = new CustomEvent('validatedeploysessionexpire', {
        bubbles: true,
        composed: true
      });
      document.dispatchEvent(validateDeploySessionExpEvent);
    } else {
      const parsedData = JSON.parse(response.entity);
      const {
        data,
        success,
        message
      } = parsedData;
      if (success) {
        const {
          jobId
        } = data;
        initiateMigrationStatusCall(jobId, isValidate);
      } else {
        clearInterval(statusTimer);
        const validateEvent = new CustomEvent('validationerror', {
          bubbles: true,
          composed: true,
          detail: message
        });
        document.dispatchEvent(validateEvent);
      }
    }
  }).catch(function (err) {
    console.log('Migration failed - Error', err);
  });
}
function initiateMigrationStatusCall(jobId, isValidate) {
  statusTimer = setInterval(() => {
    httpGetMigrateStatus(`${getApiPrefixURL()}/svmx/a360/migration/getMigrationStatus`, jobId).then(res => {
      if (res !== null && res !== undefined) {
        console.log('response - migration status', res);
        const responseEntity = JSON.parse(res.entity);
        const migrateStatusResponse = responseEntity.data;
        if (migrateStatusResponse !== null) {
          const {
            status
          } = migrateStatusResponse;
          if (isValidate && status !== VALIDATING || !isValidate && status !== INPROGRESS) {
            stopStatusTimer(migrateStatusResponse, isValidate);
          }
        }
      }
    }).catch(function (err) {});
  }, 1000);
}
function stopStatusTimer(migrateStatusResponse, isValidate) {
  clearInterval(statusTimer);
  const migrateEvent = new CustomEvent('validateanddeploy', {
    bubbles: true,
    composed: true,
    detail: {
      response: migrateStatusResponse,
      isValidate: isValidate
    }
  });
  document.dispatchEvent(migrateEvent);
}